import con from '../../../connection';
var path = '/portals';
var portals = function (url) { return function () { return ({
    get: function () { return con.get(url + path, {}); },
}); }; };
export default portals;
